import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './assets/js/App';
import Footer from './components/Footer';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
 <>
  <App/>
 <Footer/>
 </>
);